import { render, staticRenderFns } from "./PrintCheckbox.vue?vue&type=template&id=5f6a3f2c&scoped=true&"
import script from "./PrintCheckbox.vue?vue&type=script&lang=js&"
export * from "./PrintCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a3f2c",
  null
  
)

export default component.exports